// Tüm SahaLive medya yüklemeleri buradan geçer (Cloudinary unsigned upload).
// Firebase Storage yerine Cloudinary kullanıyoruz: ücretsiz ve kredi kartı istemiyor.
const CLOUD_NAME = 'dkmqdsoyc';
const UPLOAD_PRESET = 'sahalive';

const MAX_IMAGE_MB = 10;
const MAX_VIDEO_MB = 100; // Cloudinary unsigned upload sınırı

/**
 * Bir fotoğraf veya videoyu Cloudinary'ye yükler.
 * @param {File} file - <input type="file"> ile seçilen dosya
 * @returns {Promise<{ url: string, type: 'image'|'video', width: number, height: number, publicId: string }>}
 */
export async function uploadMedia(file) {
  if (!file) {
    throw new Error('Lütfen bir dosya seçin.');
  }

  const isImage = file.type.startsWith('image/');
  const isVideo = file.type.startsWith('video/');
  if (!isImage && !isVideo) {
    throw new Error('Sadece fotoğraf veya video yükleyebilirsiniz.');
  }

  const maxMB = isVideo ? MAX_VIDEO_MB : MAX_IMAGE_MB;
  if (file.size > maxMB * 1024 * 1024) {
    throw new Error(`Dosya çok büyük. En fazla ${maxMB} MB yükleyebilirsiniz.`);
  }

  const resourceType = isVideo ? 'video' : 'image';

  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', UPLOAD_PRESET);

  let resp;
  try {
    resp = await fetch(
      `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/${resourceType}/upload`,
      { method: 'POST', body: formData }
    );
  } catch (e) {
    throw new Error('Yükleme başarısız oldu. İnternet bağlantınızı kontrol edin.');
  }

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data?.error?.message || 'Yükleme sırasında bir hata oluştu.');
  }

  return {
    url: data.secure_url,
    type: resourceType,
    width: data.width,
    height: data.height,
    publicId: data.public_id,
  };
}
